import React                     from 'react'
import { Tooltip, Button, Icon } from 'antd'
import MovePopover               from '../MovePopover'
import './styles.scss'

export default ({title, value, on_search_click, on_create_folder, on_move, on_refresh, show_download_ftx }) =>{
  let move_target = null
  let copy_target = null

  return <div className='list-header'>
    <span className='header-title'>{title}</span>

    <ul className='header-icons'>
      { on_search_click &&
        <li onClick={on_search_click}>
          <Tooltip title="Search files">
            <Button icon="search" shape="circle" size={'small'}/>
          </Tooltip>
        </li>
      }
      { on_create_folder &&
        <li onClick={() => on_create_folder()}>
          <Tooltip title="Create folder">
            <Button icon="folder-add" shape="circle" size={'small'}/>
          </Tooltip>
        </li>
      }
      {/* { on_move &&
        <li>
          <MovePopover ref={n => move_target = n} target={
            <Tooltip title="Move bucket to">
              <Button shape="circle" size={'small'} onClick={() => on_move(move_target, [{path: ''}], false)}>
                <svg className="a-s-If-c a-s-fa-Ha-pa" width="24px" height="24px" viewBox="0 0 24 24" focusable="false"
                     fill="white">
                  <path fill="none" d="M0 0h24v24H0V0z"/>
                  <path fill='#b0b0b0'
                        d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6 12v-3h-4v-4h4V8l5 5-5 5z"/>
                </svg>
              </Button>
            </Tooltip>
          }/>
        </li>
      } */}
      { on_move &&
      <li>
        <MovePopover ref={n => copy_target = n} target={
          <Tooltip title="Copy bucket to">
            <Button shape="circle" size={'small'} onClick={() => on_move(copy_target, [{path: ''}], true)}>
              <Icon type="copy"/>
            </Button>
          </Tooltip>
        }/>
      </li>
      }
        { show_download_ftx &&
        <li onClick={e=>{
            e.stopPropagation()
            window.location='http://ftx.CloudFlyer.com/download/current/CloudFlyerDesktopFtxSetup.msi'
        }}>
            <Tooltip title="Download ftX client">
                <Button icon='download' shape="circle" size={'small'}/>
            </Tooltip>
        </li>
        }
      { on_refresh &&
        <li onClick={() => on_refresh()}>
          <Tooltip title="Refresh files">
            <Button icon='sync' shape="circle" size={'small'}/>
          </Tooltip>
        </li>
      }
    </ul>
  </div>
}
